export function handleScrollTop (): void {
  const content = document.querySelector('.layout-panel .content') as HTMLDivElement
  if (content) {
    content.scrollTo(0, 0)
  }
}

export function getDiffDays (start: Date, end: Date): number {
  const diff = end.getTime() - start.getTime()
  return Math.floor(diff / (1000 * 3600 * 24))
}

export function normalizeAccents (text: string): string {
  if (text) {
    return text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a')
      .replace(new RegExp('[ÉÈÊ]', 'gi'), 'e')
      .replace(new RegExp('[ÍÌÎ]', 'gi'), 'i')
      .replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o')
      .replace(new RegExp('[ÚÙÛ]', 'gi'), 'u')
      .replace(new RegExp('[Ç]', 'gi'), 'c')
  }
  return ''
}

export function objToQueryString (query: any): string {
  const decoded = Object
    .keys(query)
    .map(key => {
      if (typeof query[key] === 'object') {
        return Object.keys(query[key]).map(key2 => `${key}[${key2}]=${query[key][key2]}`)
      } else {
        return `${key}=${query[key]}`
      }
    })
    .join('&')

  return decoded
}

export async function iterateList<T> (fn: (item: T, i?: number) => Promise<void>, list: T[], index = 0): Promise<void> {
  const item = list[index]
  if (item) {
    await fn(item, index)
    await iterateList(fn, list, index + 1)
  }
}
